import * as RadixSelect from '@radix-ui/react-select';

import { Button, ButtonActions, Divider } from '~/components/granular';
import { useDropdownContext } from '../..';

import type { DropdownActionsProps } from './DropdownActions.types';

export function DropdownActions({
  applyBtnText,
  clearBtnText,
  customBtnActions = [],
  hideApplyButton,
  hideClearButton,
  handleApplyButtonClick,
  handleClearAllButtonClick,
}: DropdownActionsProps) {
  const hasCustomBtnActions = customBtnActions.length > 0;
  const shouldDisplayBtnsBlock = !hideApplyButton || !hideClearButton || hasCustomBtnActions;

  const { closeDropdown } = useDropdownContext();

  return (
    <RadixSelect.Group className="w-full">
      {/* hide whole block only if both buttons have to be hidden or if going with custom actions */}
      {shouldDisplayBtnsBlock && (
        <>
          <Divider className="w-full" />

          <div className="flex-column flex w-full justify-between px-2 py-2">
            {!hideClearButton && !hasCustomBtnActions && (
              <Button
                appearance="ghost"
                className="mx-2 w-full justify-center!"
                onClick={handleClearAllButtonClick}
                size="small"
              >
                {clearBtnText}
              </Button>
            )}

            {!hideApplyButton && !hasCustomBtnActions && (
              <Button
                appearance="default"
                className="mx-2 w-full justify-center!"
                onClick={handleApplyButtonClick}
                size="small"
              >
                {applyBtnText}
              </Button>
            )}

            {customBtnActions.length > 0 && (
              <ButtonActions
                actions={customBtnActions.map((action) => ({
                  ...action,
                  onClick: () => {
                    if (action?.closeDropdownOnClick) {
                      closeDropdown();
                    }
                    action?.onClick?.();
                  },
                }))}
                className="w-full [&>button]:w-full [&>button]:justify-center!"
              />
            )}
          </div>
        </>
      )}
    </RadixSelect.Group>
  );
}
